export default () => ({
    data: {
        phone: '',
        message: '',
    },
    loading: false,
    errors: {},
    success: '',
    action: 'callback',

    form: {
        [':class']() {
            return this.loading ? 'disabled' : '';
        },

        ['@submit.prevent']() {
            this.submit();
        },
    },

    button: {
        [':disabled']() {
            return this.loading;
        },
    },

    async submit() {
        this.loading = true;
        this.success = '';

        let form = this.$el;
        let formData = new FormData(form);

        if(form.action !== undefined) {
            this.action = form.action.value;
        }

        formData.append('lang', lang);
        
        let response = await fetch('/api/' + this.action, {
            method: 'POST',
            headers: {
                'X-csrf-token': _token
            },
            body: formData,
        });

        if (!response.ok) {
            this.errors.message = lex['form.internal_error'];
            this.loading = false;
            return;
        }

        let result = await response.json();

        this.errors = result.errors;

        if (Object.keys(this.errors).length === 0) {
            this.data = {
                name: '',
                message: '',
            };

            this.success = result.success;
        }

        this.loading = false;
    }
})
